export default "__VITE_ASSET__46d3a2a7__"